// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLOSE_WINDOW = "Zav\u0159i";
export const LIKE = "To se mi l\u00edb\u00ed";
export const YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_COMMENT = "Nem\u016f\u017ee\u0161 vid\u011bt, komu se l\u00edb\u00ed tento koment\u00e1\u0159";
export const YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_POST = "Nem\u016f\u017ee\u0161 vid\u011bt, komu se tento p\u0159\u00edsp\u011bvek l\u00edb\u00ed";
